export default __webpack_public_path__ + "static/valueAdded-36f7f67a8188a32201badc08b2417568.jpeg";